var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItaly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24.6511C18.6274 24.6511 24 19.2785 24 12.6511C24 6.02371 18.6274 0.651123 12 0.651123C5.37258 0.651123 0 6.02371 0 12.6511C0 19.2785 5.37258 24.6511 12 24.6511Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 12.6511C23.9999 7.49149 20.7434 3.09298 16.1738 1.39746V23.9047C20.7434 22.2092 23.9999 17.8106 23.9999 12.6511Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.6511C0 17.8106 3.2565 22.2092 7.82611 23.9047V1.39746C3.2565 3.09298 0 7.49149 0 12.6511Z",
    fill: "#6DA544"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItaly);
export default __webpack_public_path__ + "static/media/Italy.e01cbfaaca9f93a62f695b28f7495563.svg";
export { ForwardRef as ReactComponent };